import { PatientConsentGroup } from '@/types/patient-consent-group.model'

export class PatientGroupedConsents {
  constructor(init: Partial<PatientGroupedConsents> = {}) {
    this.consents = init.consents || []
  }

  consents: PatientConsentGroup[]
}
